import { useVehiclePaymentTerms } from '~/context/vdp/UserVehicleContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useShowTradeIncentivesCopy from '~/hooks/common/selectors/useShowTradeIncentivesCopy';
import useIsHighNetTrade from '~/hooks/vdp/useIsHighNetTrade';
import { useVehiclePrice } from '~/hooks/vdp/useVehiclePrice';
import useKBBPromo from './useKBBPromo';
import usePriceDrop from '../usePriceDrop';

type ShowAboutPrice = {
  showAboutPrice: boolean;
  showTradeIncentiveCard: boolean;
  showFactoryUpgrades: boolean;
  showPriceDrop: boolean;
  showKBBPromo: boolean;
  showOriginalPrice: boolean;
};

export default function useShowAboutPrice(): ShowAboutPrice {
  const { factoryUpgrades } = useGetVehicleDetails();
  const isHighNetTrade = useIsHighNetTrade();
  const { showKBBPromo } = useKBBPromo();
  const { showPriceDrop } = usePriceDrop();
  const vehiclePricing = useVehiclePaymentTerms();
  const { originalPrice } = useVehiclePrice();

  const { showTradeIncentive, showTaxSavings } =
    useShowTradeIncentivesCopy(vehiclePricing);

  const showFactoryUpgrades = Boolean(factoryUpgrades?.factoryUpgradesMsrp);
  const showOriginalPrice = Boolean(
    factoryUpgrades?.vehicleMsrp && factoryUpgrades.vehicleMsrp > originalPrice
  );
  const showTradeIncentiveCard =
    (showTradeIncentive || showTaxSavings) && !isHighNetTrade;

  return {
    showAboutPrice:
      showFactoryUpgrades ||
      showPriceDrop ||
      showKBBPromo ||
      showOriginalPrice ||
      showTradeIncentiveCard,
    showFactoryUpgrades,
    showPriceDrop,
    showKBBPromo,
    showOriginalPrice,
    showTradeIncentiveCard
  };
}
